// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"ec74a4d6","53":"be63cf92","75":"4a4a5006","109":"b9f7046b","204":"03a3c257","377":"0bec6445","382":"3530c9d7","453":"7a9e159d","651":"85cc465f","854":"deb5426e","867":"96d3288d","991":"f3594f56"}[chunkId] + ".chunk.js";
};